// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/ConfirmGlobalChange/ConfirmGlobalChange.css
// module id = 1679
// module chunks = 0